import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-music",
  "use": "icon-music-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-music\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<path d=\"M20,15.21h0V4H9v8.49a3.59,3.59,0,0,0-1.5-.34A3.36,3.36,0,0,0,4,15.65,3.19,3.19,0,0,0,7.31,19C9.6,19,11,17.61,11,15.7h0V6.9h7v5.44A3.5,3.5,0,1,0,16.51,19C19,19,20,17,20,15.21Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol